module.exports = __webpack_public_path__ + "fonts/karla700.b8ecef1f.woff2";